import { useState } from 'react';

import { AccordionData } from '@/services/types/common';

import AccordionItem from './AccordionItem';
import styles from './styles.module.css';

function Accordion({ items }: { readonly items: ReadonlyArray<AccordionData> }) {
  const [currentIdx, setCurrentIdx] = useState(-1);
  const btnOnClick = (idx: number) => {
    setCurrentIdx((currentValue) => (currentValue === idx ? -1 : idx));
  };

  return (
    <ul className={styles.accordion}>
      {items.map((item, idx) => (
        <AccordionItem key={item.title} data={item} isOpen={idx === currentIdx} btnOnClick={() => btnOnClick(idx)} />
      ))}
    </ul>
  );
}

export default Accordion;
